import { Text } from '@chakra-ui/react';
import React from 'react';

export function LinkDivider() {
  return (
    <Text color="gray.600" px={2}>
      |
    </Text>
  );
}
